import React, { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import styled from "styled-components";
import { PostDataPromise } from "../components/Functions/SendingData";
import { LoadingWLogo } from "../components/LoadingWLogo";
import RibbonSuggetGood from "../components/NewComp/RibbonSuggetGood";
import Intro1 from "../components/NewComp/Intro1";
import SurveyComp from "../components/NewComp/SurveyComp";
import RibbonBlogPostGood from "../components/NewComp/RibbonBlogPostGood";
import RibobonAutoBlogPost from "../components/NewComp/RibobonAutoBlogPost";
import PageBuilder from "../components/NewComp/PageBuilder";

const Styles =styled.div`
    min-height: calc(100vh - 120px);
    /* padding-top: var(--top-gap); */
    text-align: center;
    display: flex;
    flex-direction: column;
    .text {
        margin: 2rem auto;
    }
    .padding {
        width: 100%;
        height: 2rem;
    }
    .main-grid {
        display: grid;
        grid-template-columns: 6.09% repeat(12, calc(calc(84.7% / 12) - calc(17.16% / 12))) 6.09%;
        grid-column-gap: 1.56%;
        position: relative;
        align-items: center;
        justify-content: center;
        justify-items: center;
        width: 100%;
    }
    .main-grid-inner {
        display: grid;
        grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(17.16% / 12)));
        grid-column-gap: 1.56%;
        position: relative;
        align-items: center;
        justify-content: center;
        justify-items: center;
        width: 100%;
    }
    @media screen and (max-width: 850px) {
        min-height: calc(100vh - 60px);
        /* padding-top: 60px; */
        .main-grid {
            grid-template-columns: 2.22% repeat(4, calc(calc(91.12% / 4) - calc(6.66% / 4))) 2.22%;
            grid-column-gap: 2.22%;
        }
    }
`

const Campaign =(props)=>{
    const match = useRouteMatch()
    const makeItems = () => {
        return(
            <PageBuilder
                {...props} 
                name={match.params.name} 
                filters={{}}
            />
        )
    }
 
    return (
        <Styles>
            {makeItems()}
        </Styles>
    )
}
export default Campaign